<template>
  <div class="flex flex-col gap-4">
    <h2 class="text-2xl font-semibold tracking-tight uppercase tracking-wider text-muted-foreground mb-4">Ping Me.</h2>
    
    <div class="flex flex-col gap-2">
      <a href="mailto:jysngomba.rbm@gmail.com" class="text-lg font-medium hover:underline flex items-center gap-2">
        <font-awesome-icon icon="envelope" class="text-muted-foreground w-4 h-4" /> 
        jysngomba.rbn@gmail.com
      </a>
      <a href="mailto:coffee.gomba@outlook.com" class="text-lg font-medium hover:underline flex items-center gap-2">
        <font-awesome-icon :icon="['fab', 'microsoft']" class="text-muted-foreground w-4 h-4" /> 
        coffee.gomba@outlook.com
      </a>
    </div>

    <!-- <div class="flex gap-4 mt-6">
      <a href="https://github.com/jayror0" target="_blank" rel="noopener noreferrer" class="text-muted-foreground hover:text-foreground transition-colors">
        <font-awesome-icon :icon="['fab', 'github']" class="w-6 h-6" />
      </a>
      <a href="https://www.linkedin.com/in/jayro-gomba-8a7056365/" target="_blank" rel="noopener noreferrer" class="text-muted-foreground hover:text-foreground transition-colors">
        <font-awesome-icon :icon="['fab', 'linkedin']" class="w-6 h-6" />
      </a>
    </div> -->
  </div>
</template>

<script>
export default {
  name: "ContactSection",
};
</script>
